import { Component, Input, Output, EventEmitter, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs';
import { IAdminAchievement } from '../../../../Utils/_models/achievements.model';
import { AchievementsService } from '../../../../Utils/_services/admin/achievements/achievements.service';

@Component({
  selector: 'app-achievement-form',
  standalone: true,
  imports: [CommonModule, FormsModule, TooltipModule],
  templateUrl: './achievement-form.component.html',
  styleUrls: ['./achievement-form.component.css']
})
export class AchievementFormComponent implements OnInit {
  @Input() achievement: IAdminAchievement | null = null; // null = Add, object = Edit
  @Output() saved = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  isSaving = signal(false);

  formName = '';
  formDescription = '';
  formBadge = '';
  formCategory: 'swipe' | 'match' | 'reward' | 'share' = 'swipe';
  formTarget: number | null = null;

  constructor(
    private achievementService: AchievementsService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    if (this.achievement) {
      this.formName = this.achievement.name;
      this.formDescription = this.achievement.description;
      this.formBadge = this.achievement.badge;
      this.formCategory = this.achievement.category;
      this.formTarget = this.achievement.target;
    }
  }

  isFormValid(): boolean {
    return !!(this.formName && this.formDescription && this.formBadge && this.formTarget);
  }

  save(): void {
    if (!this.isFormValid()) return;
    this.isSaving.set(true);

    const payload = {
      name: this.formName,
      description: this.formDescription,
      badge: this.formBadge,
      category: this.formCategory,
      target: this.formTarget!,
    };

    const request$ = this.achievement
      ? this.achievementService.updateAchievement(this.achievement._id, payload)
      : this.achievementService.createAchievement(payload);

    request$.pipe(finalize(() => this.isSaving.set(false))).subscribe({
      next: (res) => {
        this.toastr.success(res?.data?.message || (this.achievement ? 'Achievement updated' : 'Achievement created'));
        this.saved.emit();
      },
      error: (err) => {
        this.toastr.error(err?.error?.Errors?.message || 'Something went wrong');
      }
    });
  }

  cancel(): void {
    this.cancelled.emit();
  }
  getBadgeType(badge: string): 'image' | 'icon' | 'emoji' {
    if (!badge) return 'emoji';
    if (badge.startsWith('http') || badge.startsWith('data:') || badge.startsWith('/')) {
      return 'image';
    }
    const emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/u;
    if (!emojiRegex.test(badge) && badge.length > 1) {
      return 'icon';
    }
    return 'emoji';
  }
}